export enum Settings {
    DateRange = 'DateRange',
}

export const saveSetting = (key: string, data: any) => {
    localStorage.setItem(key, JSON.stringify(data));
};

export const loadSetting = (key: string) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};

export const clearSettings = () => {
    localStorage.clear();
};

export const removeSetting = (key: string) => {
    localStorage.removeItem(key);
};
